export enum WorkshopEventStatus {
  available = 'available',
  hidden = 'hidden',
}
